import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui-kit/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui-kit/select';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui-kit/form';
import { CandidateFormValues, PROFILE_SOURCES } from '../candidate-form-schema';

const TEXT_FIELDS = [
  { name: 'FirstName', label: 'FIRST_NAME' },
  { name: 'LastName', label: 'LAST_NAME' },
  { name: 'Email', label: 'EMAIL', type: 'email' },
  { name: 'PhoneNumber', label: 'PHONE_NUMBER' },
] as const;

/** Candidate inputs for a recruitment form; must render inside its `<Form>`. */
export const CandidateFields = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<CandidateFormValues>();

  return (
    <>
      {TEXT_FIELDS.map(({ name, label, ...input }) => (
        <FormField
          key={name}
          control={control}
          name={name}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t(label)}</FormLabel>
              <FormControl>
                <Input {...input} placeholder={t(label)} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
      <FormField
        control={control}
        name="Source"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('SOURCE')}</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('SOURCE')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {PROFILE_SOURCES.map((source) => (
                  <SelectItem key={source} value={source}>
                    {source}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="Designation"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('DESIGNATION')}</FormLabel>
            <FormControl>
              <Input placeholder={t('DESIGNATION')} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="YearsOfExperience"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('YEARS_OF_EXPERIENCE')}</FormLabel>
            <FormControl>
              <Input
                type="number"
                min={0}
                {...field}
                onChange={(e) => field.onChange(e.target.valueAsNumber)}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
